import { urlBaseProfile } from "./config";
import axiosInstance from "./config/axiosinstance";

async function createProfile(data) {
  var config = {
    method: "post",
    url: `${urlBaseProfile}/profile`,
    headers: {
      "content-type": "application/json",
    },
    data: data,
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response;
    });
}

async function deleteProfile(profileId) {
  var config = {
    method: "delete",
    url: `${urlBaseProfile}/profile/${profileId}`,
    headers: {
      "content-type": "application/json",
    },
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response;
    });
}

async function updateProfile(data, profileId) {
  var config = {
    method: "put",
    url: `${urlBaseProfile}/profile/${profileId}`,
    headers: {
      "content-type": "application/json",
    },
    data: data,
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response;
    });
}

async function getProfiles({ offset, limit, search, columnSearch }) {
  var config = {
    method: "get",
    url: `${urlBaseProfile}/profile?offset=${offset}&limit=${limit}&search=${search}&columnSearch=${columnSearch}`,
    headers: {
      "content-type": "application/json",
    },
  };
  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response;
    });
}

async function getProfilesById(id) {
  var config = {
    method: "get",
    url: `${urlBaseProfile}/profile/${id}`,
    headers: {
      "content-type": "application/json",
    },
  };
  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response;
    });
}

async function getProfileScreensById(profileId) {
  var config = {
    method: "get",
    url: `${urlBaseProfile}/profile-screen/${profileId}/profile?offset=1&limit=10`,
    headers: {
      "content-type": "application/json",
    },
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response;
    });
}

async function getNotDefaultProfiles({
  offset,
  limit,
  search = "",
  columnSearch = "",
}) {
  var config = {
    method: "get",
    url: `${urlBaseProfile}/profile?offset=${offset}&limit=${limit}&search=${search}&columnSearch=${columnSearch}`,
    headers: {
      "content-type": "application/json",
    },
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response;
    });
}

export {
  createProfile,
  deleteProfile,
  getProfiles,
  getProfilesById,
  getProfileScreensById,
  getNotDefaultProfiles,
  updateProfile,
};
